import { type AggregateFunctionName } from '@blaze-shared/api-contracts-domain';

export interface Series {
  name: string;
  data: SeriesData;
  color?: string;
}

export interface CountSeriesData {
  $type: 'count';
}

export interface ValueSeriesData {
  $type: 'value';
  columnName: string;
}

export interface MinSeriesData {
  $type: 'min';
  columnName: string;
}

export interface MaxSeriesData {
  $type: 'max';
  columnName: string;
}

export interface AvgSeriesData {
  $type: 'avg';
  columnName: string;
}

export interface SumSeriesData {
  $type: 'sum';
  columnName: string;
}

export type SeriesData =
  | CountSeriesData
  | AvgSeriesData
  | ValueSeriesData
  | MinSeriesData
  | MaxSeriesData
  | SumSeriesData;

export enum OrderAxis {
  X = 'X',
  Y = 'Y',
}

export enum NumberType {
  Number = 'Number',
  Currency = 'Currency',
  Percent = 'Percent',
}

export function getAggregation(series: Series): 'FIELD VALUE' | AggregateFunctionName {
  return (series.data.$type === 'value' ? 'FIELD VALUE' : series.data.$type.toUpperCase()) as
    | AggregateFunctionName
    | 'FIELD VALUE';
}
